<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import moment from 'moment'
import { getAction } from '@/command/netTool'

export default {
  name: 'balance',
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {
        balanceType: '0',
      },
      balanceCompanyList: [],
      regionCode: [],
    }
  },
  mounted() {
    // 获取级联数据
    api.command.getRegionType.call(this, {
      url: '/api/region/list/330200',
      key: 'regionCode',
    })
    this.getBalanceCompany()
    api.command.getList.call(this, {
      url: '/farmBalance/list',
      current: 1,
    })
  },
  methods: {
    async getBalanceCompany() {
      await getAction('/api/balanceCompany/list').then((res) => {
        if (res.code == 200) {
          this.balanceCompanyList = res.data.map((e) => {
            return {
              text: e.name,
              name: e.name,
              value: e.id,
            }
          })
        }
      })
    },
    getHeader() {
      return [
        {
          name: '名称',
          key: 'name',
          type: 'input',
        },
        {
          name: '所属单位',
          key: 'balanceCompanyId',
          type: 'select',
          typeData: this.balanceCompanyList,
        },
        {
          name: '市区县',
          key: 'areaCode',
          type: 'select',
          typeData: this.regionCode,
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '券名',
          align: 'left',
        },
        {
          dataIndex: 'areaName',
          title: '市/区/县',
          align: 'center',
          customRender: (text, record) => {
            return text || '-'
          },
        },
        {
          dataIndex: 'amount',
          title: '金额',
          align: 'center',
          customRender: (text, record) => {
            if (record.mealCardFlag === '1') {
              return `-`
            }
            return text
          },
        },
        {
          dataIndex: 'sendNum',
          title: '发放人数',
          align: 'left',
        },
        {
          dataIndex: 'usedAmount',
          title: '已消费',
          align: 'left',
          customRender: (text, record) => {
            if (record.mealCardFlag === '1') {
              return `￥${text}`
            }
            return `￥${text}/￥${record.allAmount}(${record.usedRate}%)`
          },
        },
        {
          dataIndex: 'balanceCompanyName',
          title: '所属单位',
          align: 'left',
        },
        {
          dataIndex: 'useStartTime',
          title: '有效期',
          align: 'left',
          customRender: (text, record) => {
            if (!record.useStartTime || !record.useEndTime) return '无限期'
            return `${moment(record.useStartTime).format('YYYY-MM-DD')} ~ ${moment(record.useEndTime).format(
              'YYYY-MM-DD'
            )}`
          },
        },
        // {
        //   dataIndex: 'balanceType',
        //   title: '类型',
        //   align: 'left',
        //   filters: [
        //     {
        //       text: '余额券',
        //       value: '0'
        //     },
        //     {
        //       text: '余额卡',
        //       value: '1'
        //     }
        //   ],
        //   filterMultiple: false,
        //   customRender: (text, record) => {
        //     return text == 1 ? '余额卡' : '余额券'
        //   },
        //   onExport: (text, record) => {
        //     return text == 1 ? '余额卡' : '余额券'
        //   }
        // },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          width: '10%',
          typeData: ({ records }) => {
            return [
              {
                name: '充值管理',
                onClick: () => {
                  let link = {
                    0: 'indexVoucher',
                    1: 'indexCard',
                  }[records.balanceType]
                  this.$router.push({
                    path: `/marketingCenter/${link}`,
                    query: {
                      id: records.id,
                      mealCardFlag: records.mealCardFlag,
                    },
                  })
                },
              },
              {
                name: '编辑',
                onClick: () => {
                  this.$router.push({
                    path: '/marketingCenter/balanceDetail',
                    query: {
                      id: records.id,
                    },
                  })
                },
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () => {
                  api.command.del.call(this, {
                    url: '/farmBalance/del',
                    params: {
                      id: records.id,
                    },
                  })
                },
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            this.$router.push({
              path: '/marketingCenter/balanceDetail',
            })
          },
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
        filterRightButtonKey={['refresh', 'setting']}
      />
    )
  },
}
</script>
